import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { JustWinLayoutPicker } from 'Components/Modals/Investment/JustWinDialog/JustWinLayout/JustWinLayoutPicker';
import { JustWinDialogMetaOverride } from 'Components/Modals/Investment/JustWinDialog/JustWinMetaOverrides';

const JustWinContent = ({ resource, onSubmit }) => {
  return (
    <MetaResourceRenderer
      metaOverrideSet={JustWinDialogMetaOverride}
      resource={resource}
      layout={JustWinLayoutPicker}
      onSubmit={onSubmit}
    />
  );
};

JustWinContent.defaultProps = {};
JustWinContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export { JustWinContent };
